import { render, staticRenderFns } from "./DeliveryPriceCreate.vue?vue&type=template&id=e3377c1e&scoped=true"
import script from "./DeliveryPriceCreate.vue?vue&type=script&lang=js"
export * from "./DeliveryPriceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3377c1e",
  null
  
)

export default component.exports